import { render } from "./CustomUI.vue?vue&type=template&id=568753f7&scoped=true&lang=pug"
import script from "./CustomUI.vue?vue&type=script&lang=ts"
export * from "./CustomUI.vue?vue&type=script&lang=ts"

import "./CustomUI.vue?vue&type=style&index=0&id=568753f7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-568753f7"

export default script